import React from "react"
import ReactDOM from "react-dom"
import HotspotImageBlockComponent from "./hotspot-image-block-component"

export default class HotspotImageBlock {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<HotspotImageBlockComponent {...this.modelJson} />, self.elem)
  }
}
